module.exports = __webpack_public_path__ + "images/store_case_study/andrecycle-pic1_1aa7dcb70439276f3d970ce3be0ef305.jpg";